/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { pushOnePlugImage } from "../../../../middlewares/sysNavigation/SysNavigation";
import { usePlugImageContext } from "../../../../context/plugImage/PlugImageContext";
import { Modal, Search, Pagination, MyButton } from "../../component/Component";
import { _PAGE_SIZE_ } from "../../../../middlewares/other/tools";

const addRoute = "/plug/image/add";
const editRoute = "/plug/image/edit";

const Overview = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);
  const [plugImageList, setPlugImageList] = useState([]);
  const { plugImage, fetchPlugImages, count } = usePlugImageContext();

  useEffect(() => {
    if (!plugImage) fetchPlugImages(page, pageSize);
    else setPlugImageList(plugImage);
  }, [plugImage]);

  const SearchList = (e) => {
    const key = String(e.target.value).toLowerCase();
    let searchArray = [];
    if (plugImage) {
      plugImage?.map((pImage) => {
        if (String(pImage?.type).toLowerCase().includes(key))
          return searchArray.push(pImage);
        return true;
      });
    }

    setPlugImageList(searchArray);
    if (key === "") setPlugImageList(plugImage);
  };

  return (
    <div className="h-full overflow-y-auto bg-gray-50">
      <div className="mx-auto max-w-6xl p-4 lg:p-6">
        {/* Header */}
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <span className="grid h-10 w-10 place-items-center rounded-xl bg-gray-900 text-white">
              <svg
                className="h-5 w-5"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M19 3H5a2 2 0 00-2 2v14a1 1 0 001.555.832l4.89-3.26a2 2 0 012.11-.058l2.68 1.49a2 2 0 002.021-.083l4.58-3.053A2 2 0 0022 12.073V5a2 2 0 00-2-2z" />
              </svg>
            </span>
            <div>
              <h1 className="text-lg font-semibold tracking-tight text-gray-900">
                Plug Images
              </h1>
              <p className="text-sm text-gray-600">
                Browse, edit, and manage all plug images.
              </p>
            </div>
          </div>

          <span className="rounded-full bg-gray-100 px-3 py-1 text-xs font-semibold text-gray-700">
            Total: {count ?? 0}
          </span>
        </div>

        {/* Toolbar */}
        <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-3">
          <div className="sm:col-span-2">
            <Search
              props={{
                title: "Plug Image",
                onChange: (e) => SearchList(e),
              }}
            />
          </div>
          <div className="sm:justify-self-end">
            <Link to={addRoute}>
              <MyButton
                title="Add Plug Image"
                className="w-full sm:w-auto rounded-lg bg-gray-900 px-4 py-2.5 font-medium text-white shadow-sm hover:bg-black"
                onClick={() => { }}
              />
            </Link>
          </div>
        </div>

        {/* Table card */}
        <div className="mt-5 overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead className="sticky top-0 z-10 bg-white/90 backdrop-blur">
                <tr className="text-xs uppercase tracking-wide text-gray-500">
                  <th className="w-1/2 border-b border-gray-200 px-4 py-3 font-semibold">
                    <div className="inline-flex items-center gap-2">
                      <svg
                        className="h-4 w-4 text-gray-400"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path d="M21 11.5 12.5 3H6a3 3 0 00-3 3v6.5L11.5 21a2.121 2.121 0 003 0l6.5-6.5a2.121 2.121 0 000-3zM7.5 8A1.5 1.5 0 119 6.5 1.5 1.5 0 017.5 8z" />
                      </svg>
                      Type
                    </div>
                  </th>
                  <th className="w-1/2 border-b border-gray-200 px-4 py-3 text-right font-semibold">
                    <div className="inline-flex items-center gap-2">
                      <svg
                        className="h-4 w-4 text-gray-400"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <circle cx="5" cy="12" r="2" />
                        <circle cx="12" cy="12" r="2" />
                        <circle cx="19" cy="12" r="2" />
                      </svg>
                      Actions
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-100">
                {plugImage ? (
                  plugImageList?.length ? (
                    plugImageList?.map((pImage, key) => (
                      <tr
                        key={key}
                        className="hover:bg-gray-50/80 transition-colors"
                      >
                        <td className="px-4 py-3 align-middle">
                          <span className="inline-flex items-center rounded-md bg-gray-100 px-2.5 py-1 text-xs font-semibold text-gray-700 ring-1 ring-inset ring-gray-200">
                            {pImage?.type}
                          </span>
                        </td>
                        <td className="px-4 py-3 align-middle">
                          <div className="flex justify-end">
                            <ActionButton props={pImage} />
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={2}
                        className="px-4 py-10 text-center text-sm text-gray-500"
                      >
                        No plug images match your search.
                      </td>
                    </tr>
                  )
                ) : (
                  <tr>
                    <td className="px-4 py-6 text-gray-400">...</td>
                    <td className="px-4 py-6 text-right text-gray-400">...</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        <div className="mt-4">
          <Pagination
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total_items={count}
            callbackFunction={(_page_, _pageSize_) => {
              fetchPlugImages(_page_, _pageSize_);
            }}
          />
        </div>
      </div>
    </div>
  );
};

/**
 *  @author Ntavigwa Bashombe
 * @param {*} props
 * @returns
 */
const ActionButton = ({ props }) => {
  const { plugImage, updatePlugImageState, deletePlugImage } =
    usePlugImageContext();

  const [showModal, setShowModal] = useState(false);

  const plug_image_id = props.plug_image_id;
  const plugImage_name = props.type;
  const pImage = props;

  const deleteOnePlugImageById = async (plug_image_id) => {
    const { status } = await deletePlugImage(plug_image_id);
    if (status === 200) {
      if (plugImage) {
        const update = plugImage?.filter(
          (pImage) => pImage?.plug_image_id !== plug_image_id
        );
        updatePlugImageState(update);
        setShowModal(false);
      }
    }
  };

  return (
    <>
      <Modal
        props={{
          name: plugImage_name,
          showModal: showModal,
          setShowModal: () => setShowModal(false),
          delete: () => deleteOnePlugImageById(plug_image_id),
        }}
      />

      <div className="flex items-center gap-2">
        <Link to={editRoute}>
          <MyButton
            title="Edit"
            className="rounded-lg bg-blue-600 px-4 py-2 text-white shadow-sm hover:bg-blue-700"
            onClick={() => pushOnePlugImage(pImage)}
          />
        </Link>
        <MyButton
          title="Delete"
          className="rounded-lg bg-red-600 px-4 py-2 text-white shadow-sm hover:bg-red-700"
          onClick={() => setShowModal(true)}
        />
      </div>
    </>
  );
};

export default Overview;
